import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProductsService } from '../../services/products.service';
import { ProductListService } from './product-list.service';
import { SnackBarService } from '../../services/snack-bar.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-product-list',
    templateUrl: './product-list.component.html',
    styleUrls: ['./product-list.component.scss'],
    standalone: false
})
export class ProductListComponent implements OnInit, OnDestroy {
    private unsubscribe$: Subject<void> = new Subject<void>();
    public productListViewModel: any[];

    constructor(
        public productListService: ProductListService,
        private productService: ProductsService,
        private snackBarService: SnackBarService,
        private translateService: TranslateService
    ) {}

    public ngOnInit() {
        this.productListService.productList$.pipe(takeUntil(this.unsubscribe$)).subscribe({
            next: (products) => {
                this.productListViewModel = this.productService.getProductListViewModel(products);
            },
            error: (error) => {
                this.snackBarService.openSnackBar({
                    message: this.translateService.instant('CONFIGURATION.SNACK_BAR.FETCH_PRODUCTS.ERROR'),
                    isFailure: true,
                });
                if (error.error?.message) {
                    // tslint:disable-next-line:no-console
                    console.log(error.error.message);
                }
            },
        });
    }

    public ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
